import { InMemoryCache } from '@apollo/client/cache';
import { relayStylePagination } from '@apollo/client/utilities';

import configurationService from '../../services/configurationService';
import createGraphqlClient from '../graphqlClient/createGraphqlClient';

export const clientCacheOptions = {
  typePolicies: {
    Query: {
      fields: {
        hirerActivitiesByJob: relayStylePagination(),
      },
    },
  },
};

const hirerGraphqlClient = createGraphqlClient({
  apiUri: configurationService.getHirerGraphqlUrl(),
  apiName: 'hirer-graphql-api',
  cache: new InMemoryCache(clientCacheOptions),
  credentials: 'omit',
});
export default hirerGraphqlClient;
